const prefix_local = 'fanfest'

const persistentData = {
  setData(property, value, json = false) {
    if (json) value = JSON.stringify(value)
    localStorage.setItem(`${prefix_local}-${property}`, value)  
  },
  getData(property, json = false) {
    if (json) return JSON.parse(localStorage.getItem(`${prefix_local}-${property}`))
    return localStorage.getItem(`${prefix_local}-${property}`)
  },
  removeData(property) {
    localStorage.removeItem(`${prefix_local}-${property}`)
  }
}

export default persistentData;